
(function ($) {

  function ready() {
    var instantAnswer = $('.instant-answer');
    if (instantAnswer.length > 0) {
      if (ux.traffic && ux.traffic.custom) {
        var id = instantAnswer.attr('data-ia-id');
        var title = instantAnswer.attr('data-ia-title');
        ux.traffic.custom('notify',
          'mcx.help.instant-answer.impression',
          [
            ['id', id],
            ['title', title],
            ['plId', requestContext.plId]
          ]);
      }
    }
  }

  function displayThanks() {
    $('#ia-rating-was-helpful').hide();
    $('#ia-rating-thank-you').show();

    $('.ia-rating-btn').hide();
  }

  function ratingClick(/* wasHelpful*/) {
    displayThanks();
    return false;
  }

  $('#ia-rating-yes').on('click', function () { ratingClick(true); });
  $('#ia-rating-no').on('click', function () { ratingClick(false); });
  $(document).ready(ready);

}(jQuery));
